import script from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesPage.vue?vue&type=style&index=0&id=2ee874ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee874ff"]])

export default __exports__